import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getInvitationInfo } from '../../redux/reducers/collaboratorSlice';
import { AppDispatch } from '../../redux/store';
import OmniNotification from '../../components/OmniNotification';
import { Spin } from 'antd';
import { InvitationEmailDto } from '../../api';
import LoginConfig from 'auth/loginConfig';
import { useAuth0 } from '@auth0/auth0-react';
import SignUpConfig from '../../auth/signUpConfig';
import { useQuery } from '../../utils/locationUtils';
import { Redirect } from 'react-router-dom';
import { initInternalization } from '../../localization/localization';
import { TFunction } from 'i18next';

export default function InvitationPage() {
	const { loginWithRedirect, isAuthenticated } = useAuth0();
	const dispatch: AppDispatch = useDispatch();
	const query = useQuery();
	const [isLoading, setIsLoading] = useState(true);
	const [errorWasRaised, setErrorWasRaised] = useState(false);
	const [invitationInfo, setInvitationInfo] = useState<InvitationEmailDto>();
	const invitationId = parseInt(query.get('invitationId') ?? '');
	const invitationType = query.get('type') ?? '';
	const i18n = useRef<TFunction>();
	useEffect(() => {
		const getInvitationEmail = async () => {
			i18n.current = await initInternalization();
			setIsLoading(true);
			if (!invitationId) {
				setErrorWasRaised(true);
			} else {
				if (invitationType != 'test') {
					const result = await dispatch(getInvitationInfo(invitationId));
					if (getInvitationInfo.fulfilled.match(result)) {
						setInvitationInfo(result.payload);
					} else {
						showError();
					}
				}
			}
			setIsLoading(false);
		};

		getInvitationEmail();
	}, []);

	const showError = () => {
		i18n.current &&
			OmniNotification.error({
				message: i18n.current('notification.error.title'),
				description: i18n.current('invitation.expired'),
			});
		setErrorWasRaised(true);
	};

	const redirectUser = (invitation: InvitationEmailDto | undefined) => {
		let loginConfig = {
			...LoginConfig,
			login_hint: invitation?.email ?? '',
		};

		const isTestEmail = invitationType == 'test';

		if (isAuthenticated) {
			if (!isTestEmail) {
				return <Redirect to="/" />;
			} else {
				return <Redirect to={'/test-invitation?id=' + invitationId} />;
			}
		} else {
			if (!isTestEmail) {
				if (!invitation?.isEmailRegistered) {
					loginConfig = {
						...SignUpConfig,
						login_hint: invitation?.email ?? '',
					};
					return loginWithRedirect(loginConfig);
				} else {
					return loginWithRedirect(loginConfig);
				}
			} else {
				loginConfig.redirectUri =
					window.location.origin + '/test-invitation?id=' + invitationId;
				return loginWithRedirect(loginConfig);
			}
		}
	};

	if (isLoading) return <Spin />;

	if (errorWasRaised) return <Redirect to="/" />;

	return <>{redirectUser(invitationInfo)}</>;
}
